export enum I4bCellConcept {
  ASSET_EVENTS = 'ASSET EVENTS',
  ASSET_TAGS = 'ASSET TAGS',
  ASSET_TEMPLATES = 'ASSET TEMPLATES',
  ASSET_VARIABLES = 'ASSET_VARIABLES',
  ASSETS = 'ASSETS',
  AUDIT_TRAIL = 'AUDIT TRAIL',
  CALENDARS = 'CALENDARS',
  CONNECTORS = 'CONNECTORS',
  CUSTOM_VARIABLES = 'CUSTOM VARIABLES',
  DEVICE_CALL_LOGS = 'DEVICE CALL LOGS',
  DEVICE_EVENTS = 'DEVICE EVENTS',
  DEVICE_EVENTS_TAGS = 'DEVICE EVENTS TAGS',
  DEVICE_TAGS = 'DEVICE TAGS',
  DEVICE_TEMPLATES = 'DEVICE TEMPLATES',
  DEVICE_VARIABLES = 'DEVICE_VARIABLES',
  PERIPHERALS = 'PERIPHERALS',
  DEVICES = 'DEVICES',
  DIAGNOSTIC_VARIABLES = 'DIAGNOSTIC VARIABLES',
  CONNECTIVITY_MODULE = 'CONNECTIVITY_MODULE',
  EMAIL_TEMPLATES = 'EMAIL TEMPLATES',
  EVENT_TAGS = 'EVENT TAGS',
  EVENTS = 'EVENTS',
  EVENTS_TAGS = 'EVENTS TAGS',
  FAVORITE_VIEWS = 'FAVORITE VIEWS',
  FIRMWARES = 'FIRMWARES',
  FOLLOWED_VARIABLES = 'FOLLOWED VARIABLES',
  GEOLOCATION = 'GEOLOCATION',
  GRIDS = 'GRIDS',
  KERCOM = 'KERCOM',
  PO_EVENT_RULES = 'PO EVENT RULES',
  PRODUCTS = 'PRODUCTS',
  SCHEDULERS = 'SCHEDULERS',
  SENSORS = 'SENSORS',
  SITES = 'SITES',
  SITE_TAGS = 'SITE TAGS',
  STANDARD_VARIABLES = 'STANDARD VARIABLES',
  TAGS = 'TAGS',
  TEAM_PLANNINGS = 'TEAM PLANNINGS',
  TECHNICAL = 'TECHNICAL',
  USERS = 'USERS',
  VARIABLES = 'VARIABLES',
  ESCALATION_PROTOCOLS = 'ESCALATION PROTOCOLS',
  TOPICS = 'TOPICS',
  USER_API_KEYS = 'USER_API_KEYS'
}
